import { render, staticRenderFns } from "./TableColumnItem.vue?vue&type=template&id=37a2b95a&scoped=true&"
import script from "./TableColumnItem.vue?vue&type=script&lang=js&"
export * from "./TableColumnItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2b95a",
  null
  
)

export default component.exports